import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { CheckmarkWhite, CheckmarkDark } from "@app/components/common/icons";
import { BlockHeader } from "@app/components/common/block-header/BlockHeader";
import { IRichText, TextType } from "@app/models/storyblok/basic";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { InnerTextBlock } from "../../models";
import { BlockBody } from "../../../common/block-body/BlockBody";

type Props = {
  items: InnerTextBlock[];
  title?: IRichText<TextType>;
  isColorBackground?: boolean;
  isTopMarginDisabled?: boolean;
};

export const CheckmarkIconsList: FC<Props> = ({
  items,
  title,
  isColorBackground,
  isTopMarginDisabled,
}) => (
  <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
    <div
      className={classNames("mt-20 px-5", "lg:mt-25 lg:px-16", "xl:px-24", {
        "bg-dark py-20 lg:py-25 xl:py-30": isColorBackground,
        "xl:mt-40": !isTopMarginDisabled,
        "xl:mt-0": isTopMarginDisabled,
      })}
    >
      <div className={classNames("xl:max-w-container text-center xl:mx-auto")}>
        {title ? (
          <BlockHeader
            richText={title}
            className={classNames(
              "text-medium text-primary-content mx-auto mb-15",
              "md:max-w-3/4",
              "lg:text-large lg:mb-20",
              "xl:max-w-container-small xl:text-xx-large xl:mb-25",
            )}
          />
        ) : null}
        <div
          className={classNames(
            "grid grid-cols-1 gap-y-15",
            "md:grid-cols-2",
            "lg:grid-cols-3",
          )}
        >
          {items.map((item) => (
            <div
              key={item._uid}
              className={classNames(
                "text-regular text-primary-content px-2.5 text-center",
                "md:px-10",
                "lg:px-10",
                "xl:text-medium xl:px-15",
              )}
            >
              {isColorBackground ? (
                <CheckmarkWhite className="mx-auto mb-5 h-[84px] w-[84px]" />
              ) : (
                <CheckmarkDark className="mx-auto mb-5 h-[84px] w-[84px]" />
              )}
              <BlockBody richText={item.title} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </Fade>
);
